
import { MapLocation } from '@/types/location';

// Rhythm Calisthenics Gym Locations
export const rhythmCalisthenicsGyms: MapLocation[] = [
  {
    id: 26001,
    name: "Rhythm Calisthenics - Riyadh (Malga)",
    type: "Gym",
    devices: 1,
    coordinates: [24.806195236421036, 46.603225077911716],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-40",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
